<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow; let i = index">
					<td class="text-nowrap">
						{{ item.clicked_on | date: ac.tableDateTimeFmt }}
					</td>
					<td *ngIf="showUserInfo" class="cp-chopped-col-medium" [title]="tt.escapeForTitle(item['__username'])">
						<a *ngIf="linkUser && item.added_by !== 0" [routerLink]=" ['/' + ac.urls.users, item.clicked_by]"
							[ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</a>
						<span *ngIf="!linkUser || item.added_by === 0" [ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</span>
					</td>
					<td class="cp-chopped-col-long" [title]="item.url">
						<span [ngbTooltip]="item.url">
							{{ item.url }}
						</span>
					</td>
					<td class="text-nowrap">{{ item.location }}</td>
					<td>{{ item['__browser'] }}</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>